import { MessageHeader } from 'semantic-ui-react'

const Title = ({ children }) => {
    return (
      <MessageHeader>
          {children}
      </MessageHeader>
    )
}

export { Title }
